<template>
  <div :class="description">
   <div class="d-none d-sm-block">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link to="/">Übersicht</router-link>
        </li>
        <li class="breadcrumb-item"><router-link to="/stammdaten">Stammdaten</router-link></li>
        <li class="breadcrumb-item"><router-link
            :to="backlink()">{{ description() }}</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">bearbeiten</li>
      </ol>
    </nav>
   </div>

   <div v-if="loading" class="d-flex justify-content-center mb-3">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <h4>{{ humanName() }} bearbeiten</h4>
    <div v-if="error()" class="alert alert-danger">{{ error() }}</div>
    <b-form @submit="onSubmit" @reset="onReset">
    <div v-for="(item, index) in formInfo.items" :key="item.name">
      <b-form-group v-if="item.visible" :id="labelId(index)" :label="label(item)"
        :label-for="id(index)">
        <b-form-input
        v-if="isChar(item)" :id="id(index)" v-model="form[item.name]"
        :type="item.type" :placeholder="placeholder(item)"
        :required="item.required" :readonly="isEditable(item)"></b-form-input>
        <b-form-select v-if="isSelect(item)" v-model="form[item.name]" >
           <option v-for="(sp, idx) in item.selectOptions" v-bind:key="idx" :value="sp.id">{{sp.text}}</option>
        </b-form-select>
        <b-form-file
        v-if="isFile(item)" :id="id(index)" v-model="form[item.name]"
        placeholder="Datei auswählen..."
        drop-placeholder="Datei hier her ziehen..."></b-form-file> <b-form-textarea
        v-if="isText(item)" :id="id(index)" v-model="form[item.name]"
        placeholder="Wert eingeben" rows="3" max-rows="6"></b-form-textarea>

       <b-form-checkbox v-if="item.type==='boolean'" v-model="form[item.name]" switch/>
      <div class="text-warning">{{ validation[item.name] }}</div>
      </b-form-group>
    </div>
    <b-button type="submit" variant="primary">speichern</b-button><b-button
      type="reset" variant="default">Reset</b-button> </b-form>
  </div>
</template>
<script>
import api from '@/api/generic'
import utils from '@/utilities'
export default {
  name: 'Stammdaten',
  data () {
    return {
      loading: false,
      selected: null,
      form: {},
      validation: {},
      formInfo: {}
    }
  },
  mounted () {
    this.refresh()
  },
  methods: {
    error () {
      return this.validation['ErrorMessage']
    },
    description () {
      return this.$route.params.type
    },
    humanName () {
      return this.formInfo['humanName']
    },
    resultInfo (item) {
      return item.name
    },
    onReset (event) {
    },
    // take a single JavaScript File object
    getFile (file) {
      var reader = new FileReader()
      return new Promise((resolve, reject) => {
        reader.onerror = () => { reader.abort(); reject(new Error('Error parsing file')) }
        reader.onload = function () {
          // This will result in an array that will be recognized by C#.NET WebApi as a byte[]
          let bytes = Array.from(new Uint8Array(this.result))

          // if you want the base64encoded file you would use the below line:
          let base64StringFile = btoa(bytes.map((item) => String.fromCharCode(item)).join(''))

          // Resolve the promise with your custom file structure
          resolve({
            bytes: bytes,
            base64StringFile: base64StringFile,
            fileName: file.name,
            fileType: file.type
          })
        }
        reader.readAsArrayBuffer(file)
      })
    },
    async onSubmit (event) {
      event.preventDefault()
      let httpForm = new FormData()
      for (let [key, value] of Object.entries(this.form)) {
        // files lassen sich zwar einfach übertragen aber auf der rest seite nicht generisch behandeln (kommen als kaputte strings an..)
        // deswegen konvertieren wir files ins base64 und auf der anderen seite wieder zurück
        if (value instanceof File) {
          const jsonFile = await this.getFile(value)
          if (this.hasField('mimetype')) {
            httpForm.append('mimetype', jsonFile.fileType)
          }
          httpForm.append(key, jsonFile.base64StringFile)
          // FIXME: bad hack
          if (this.$route.params.type === 'Datei') {
            httpForm.append('name', jsonFile.fileName)
          }
        } else {
          httpForm.append(key, value)
        }
      }
      let id = 0
      if (this.form.id !== undefined) {
        id = this.form.id
      }
      this.validation = await api.update(this.$route.params.type, id, httpForm)
      if (Object.keys(this.validation).length === 0) {
        // eslint-disable-next-line
        utils.makeToast(this.$root, this.$route.params.id != 0 ? 'Eintrag geändert!' : 'Eintrag angelegt', 'success')
        this.$router.push(this.backlink())
      } else {
        utils.makeToast(this, this.validation['errorMessage'], 'danger')
      }
    },
    placeholder (item) {
      return !this.isEditable(item) ? 'Wert eingeben' : 'automatisch'
    },
    capitalizeFirstLetter ([ first, ...rest ]) {
      return [ first.toUpperCase(), ...rest ].join('')
    },
    backlink () {
      return '/stammdaten/' + this.$route.params.type
    },
    hasField (name) {
      for (let i = 0; this.formInfo.items; i++) {
        if (this.formInfo.items[i].name === name) {
          return true
        }
      }
      return false
    },
    isEditable (item) {
      return !item.editable
    },
    isChar (item) {
      return item.type !== 'select' && item.type !== 'boolean' && item.size < 256 && item.visible
    },
    isSelect (item) {
      return item.type === 'select'
    },
    isFile (item) {
      return item.type === 'file' && item.visible
    },
    isText (item) {
      return item.type === 'text' && item.size > 256 && item.visible
    },
    label (item) {
      return (item.description ? item.description : this.capitalizeFirstLetter(item.name)) + (item.required ? ' *' : '')
    },
    id (index) {
      return 'input-' + index
    },
    labelId (index) {
      return 'input-group-' + index
    },
    async refresh () {
      this.loading = true
      this.formInfo = await api.information(this.$route.params.type)
      if (this.$route.params.id !== 0) {
        this.form = await api.get(this.$route.params.type, this.$route.params.id)
      } else {
      }
      this.loading = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/StammdatenEditor.vue